import { useState, useEffect } from "react";
import { Biscuit } from "../../../../utils";

let currentLocation = null;

/**
 * Observes currentLocation to check whether it shall
 * be writable by user (if is manager-location)
 * @param {String|Number} newLocation (If any given)
 */
export default function useManagerHasLocation(newLocation = null) {
  if (newLocation) {
    currentLocation = newLocation;
  }

  const userRole = Biscuit.get("user.role");

  const [managerHasLocation, setManagerHasLocation] = useState(
    userRole === "admin" || userRole === "booking-manager",
  );

  useEffect(() => {
    if (currentLocation && userRole === "manager-location") {
      let managerLocations = Biscuit.get("user.user_locations");

      if (managerLocations !== "") {
        managerLocations = managerLocations.split(",");
      }

      if (managerLocations.length) {
        if (managerLocations.some((location) => Number(location) === Number(currentLocation))) {
          setManagerHasLocation(true);
        }
      }
    }

    return () => {
      if (userRole !== "admin" && userRole !== "booking-manager") {
        setManagerHasLocation(false);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLocation]);

  return {
    managerHasLocation,
  };
}
